import { ElementTypes } from '../types'

const withCodiQuote = (editor) => {
  const { isInline, isVoid, markableVoid, deleteForward, deleteBackward } =
    editor

  editor.isInline = (element) => {
    return element.type === ElementTypes.CODI_QUOTE ? true : isInline(element)
  }

  editor.isVoid = (element) => {
    return element.type === ElementTypes.CODI_QUOTE ? true : isVoid(element)
  }

  editor.markableVoid = (element) => {
    return element.type === ElementTypes.CODI_QUOTE || markableVoid(element)
  }

  return editor
}

export default withCodiQuote
